import { ActionIcon, Alert, Box, Button, Divider, Grid, Group, Image, Loader, LoadingOverlay, Modal, Paper, Stack, Text, Title, UnstyledButton, useMantineTheme } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import React, { useEffect, useState } from "react";
import InputField, { InputFieldMasks, InputFieldTypes } from "../components/input_field";
import { HtmlEditor } from "../components/html_editor";
import { useApp } from "../contexts/app.context";
import { DELETE_KNOWLEDGE, DELETE_KNOWLEDGE_CATEGORY, GET_ALL_KNOWLEDGES, SAVE_KNOWLEDGE, SAVE_KNOWLEDGE_CATEGORY } from "../services/knowledges";
import { FaArrowLeft, FaEdit, FaPaperclip, FaPlus } from "react-icons/fa";
import SunEditor from 'suneditor-react';
import { useNavigate } from "react-router-dom";
import SimpleHeader from "../components/simple_header";
import { useMediaQuery } from "@mantine/hooks";
import { FaTrash } from "react-icons/fa6";
import { useAuth } from "../contexts/auth.context";
import { useLanguage } from "../contexts/language.context";

export default function KnowledgesPage() {
    const [knowledges, setKnowledges] = useState<any[]>([]);
    const [selectedKnowledgeCategory, setSelectedKnowledgeCategory] = useState<any>(null);
    const [selectedKnowledge, setSelectedKnowledge] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingSave, setLoadingSave] = useState<boolean>(false);
    const [loadingDelete, setLoadingDelete] = useState<boolean>(false);

    const { str } = useLanguage();
    const theme = useMantineTheme();
    const isMobile = useMediaQuery('(max-width: 900px)');

    const { confirmDialog } = useApp();
    const { userData } = useAuth();

    const loadKnowledges = () => {
        setLoading(true);
        GET_ALL_KNOWLEDGES()
            .then(res => {
                setKnowledges(res);
                if (selectedKnowledgeCategory) {
                    setSelectedKnowledgeCategory(res.find(r => r.id === selectedKnowledgeCategory?.id) ?? selectedKnowledge)
                }
            })
            .catch(err => {
                notifications.show({ message: err.message, color: "red" })
            })
            .finally(() => {
                setLoading(false);
            })
    }

    const handleSaveCategory = () => {
        let params = { ...selectedKnowledgeCategory };

        setLoadingSave(true)
        SAVE_KNOWLEDGE_CATEGORY(params)
            .then((res) => {
                notifications.show({ message: "Knowledge base saved!", color: "green" })
                loadKnowledges();
                setSelectedKnowledgeCategory(res)
                setLoadingSave(false);
            })
            .catch(err => {
                notifications.show({ message: err.message, color: "red" })
                setLoadingSave(false);
            })
    }

    const handleSave = () => {
        let params = { ...selectedKnowledge };

        setLoadingSave(true)
        SAVE_KNOWLEDGE({ ...params, category: selectedKnowledgeCategory.id })
            .then((res) => {
                notifications.show({ message: "Item saved!", color: "green" })
                loadKnowledges();
                setSelectedKnowledge(null)
                setLoadingSave(false);
            })
            .catch(err => {
                notifications.show({ message: err.message, color: "red" })
                setLoadingSave(false);
            })
    }

    const handleDelete = (itemId: string) => {
        confirmDialog({ text: "Delete this knowledge?" }, ({ confirmed }) => {
            if (confirmed) {
                setLoadingDelete(true)
                DELETE_KNOWLEDGE(itemId)
                    .then((res) => {
                        loadKnowledges();
                        setSelectedKnowledge(null);
                        setLoadingDelete(false);
                    })
                    .catch(err => {
                        notifications.show({ message: err.message, color: "red" })
                        setLoadingDelete(false);
                    })
            }
        })
    }

    const handleDeleteCategory = (catId: string) => {
        confirmDialog({ text: "Delete this knowledge base?" }, ({ confirmed }) => {
            if (confirmed) {
                setLoadingDelete(true)
                DELETE_KNOWLEDGE_CATEGORY(catId)
                    .then((res) => {
                        loadKnowledges();
                        setSelectedKnowledge(null);
                        setLoadingDelete(false);
                    })
                    .catch(err => {
                        notifications.show({ message: err.message, color: "red" })
                        setLoadingDelete(false);
                    })
            }
        })
    }

    useEffect(loadKnowledges, []);

    return <div style={{ position: 'relative' }}>
        <LoadingOverlay visible={loading} />
        <SimpleHeader
            variant="light"
            title={str("KNOWLEDGE.TITLE")}
            button={{
                title: str("NEW"), leftSection: <FaPlus />, onClick: () => {
                    setSelectedKnowledgeCategory({})
                }
            }} />

        <Paper shadow='xs' style={{ padding: 0 }}>
            <Grid gutter={0}>
                {(!isMobile || !selectedKnowledgeCategory) && <Grid.Col span={{ base: 12, md: 4 }} style={{ minHeight: '70vh' }}>
                    <Box style={{ height: '100%' }}>


                        {knowledges.map((knowledge) => (
                            <UnstyledButton style={{ width: '100%' }} onClick={() => {
                                // if(!allowed) notifications.show({
                                //     title: "Payment required",
                                //     message: "Check for your billing settings, there is one payment subscription that failed, change your payment method and try again.",
                                //     color: "yellow"
                                // })
                                setSelectedKnowledgeCategory(knowledge)
                            }}>
                                <Group
                                    style={{ borderRight: `7px solid ${selectedKnowledgeCategory?.id === knowledge.id ? "black" : "transparent"}` }}
                                    p="xl"
                                >
                                    <Box style={{ flex: 1 }}>
                                        <Text size="md" fw="bold" c="gray.0">{knowledge?.title}</Text>
                                    </Box>
                                </Group>
                                <Divider />
                            </UnstyledButton>
                        ))}
                    </Box>
                </Grid.Col>}
                {(!isMobile || selectedKnowledgeCategory) && <Grid.Col span={{ base: 12, md: 8 }} style={{ minHeight: '70vh', backgroundColor: theme.colors.dark[9] }}>
                    {isMobile && <Group p="md">
                        <ActionIcon size="xl" onClick={() => setSelectedKnowledgeCategory(null)}><FaArrowLeft /></ActionIcon>
                    </Group>}
                    <Box p="md">
                        {knowledges.length === 0 && !loading && (
                            <Paper p="xl" m="md" withBorder>
                                <Stack align="center" gap="sm">
                                    <Text fw={700} size="lg">{str("KNOWLEDGE.TITLE")}</Text>
                                    <Text c="dimmed" ta="center">{str("KNOWLEDGE.EMPTY_STATE")}</Text>
                                    <Button leftSection={<FaPlus />} onClick={() => setSelectedKnowledgeCategory({})}>
                                        {str("KNOWLEDGE.CREATE_FIRST")}
                                    </Button>
                                </Stack>
                            </Paper>
                        )}
                        {selectedKnowledgeCategory?.id && <>
                            <Group mb="md">
                                <ActionIcon onClick={() => setSelectedKnowledgeCategory(null)}><FaArrowLeft /></ActionIcon>
                                <Text
                                    contentEditable
                                    onBlur={(e: any) => setSelectedKnowledgeCategory(kc => ({ ...kc, title: e.target.textContent }))}
                                    fw="bold" size="xl" style={{ flex: 1 }}>{selectedKnowledgeCategory.title}</Text>
                                <ActionIcon
                                    variant="light"
                                    color="red"
                                    size="lg"
                                    onClick={() => handleDeleteCategory(selectedKnowledgeCategory?.id)}
                                    loading={loadingSave}
                                ><FaTrash /></ActionIcon>
                                <Button
                                    variant="filled"
                                    onClick={handleSaveCategory}
                                    loading={loadingSave}
                                >{str("SAVE")}</Button>
                            </Group>

                            <Grid>
                                <Grid.Col span={{ base: 12, md: 6 }}>
                                    <UnstyledButton style={{ width: '100%' }} onClick={() => { setSelectedKnowledge({}) }}>
                                        <Paper p="md" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 200 }}>
                                            <FaPlus size={40} color="#8a8a8a" />
                                            <Text c="#8a8a8a" mt="md" size="xl" fw="bold">{str("NEW")}</Text>
                                        </Paper>
                                    </UnstyledButton>
                                </Grid.Col>

                                {
                                    (selectedKnowledgeCategory?.items ?? [])
                                        .map((kc: any) => (
                                            <Grid.Col span={{ base: 12, md: 6 }}>
                                                <UnstyledButton style={{ width: '100%' }}
                                                    onClick={() => {
                                                        setSelectedKnowledge(kc)
                                                    }}
                                                >
                                                    <Paper p="md" style={{ minHeight: 200, display: 'flex', flexDirection: 'column' }}>
                                                        {
                                                            kc.type === "url"
                                                                ? <Stack>
                                                                    <Text fw="bold" size="md">{str("WEBSITE")}</Text>
                                                                    {kc.urls.map((url: string) => <Button onClick={() => { window.open(url, "_blank") }}>
                                                                        {url}
                                                                    </Button>)}
                                                                </Stack>
                                                                : kc.type === "file"
                                                                    ? <>
                                                                        <Text fw="bold" size="md">{kc.title}</Text>
                                                                        <Box p="sm" mt="md" style={{ background: '#EFEFEF', borderRadius: 10, flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                                                            <FaPaperclip color="#8a8a8a" size={40} />
                                                                            <Text ta="center" c="#8a8a8a" mt="xs" size="md">{str("FILE")}</Text>
                                                                        </Box>
                                                                    </>
                                                                    : <>
                                                                        <Text fw="bold" size="md">{kc.title}</Text>
                                                                        <Text size="sm" mt="xs" lineClamp={6}>{kc.body}</Text>
                                                                    </>
                                                        }
                                                    </Paper>
                                                </UnstyledButton>
                                            </Grid.Col>
                                        ))}
                            </Grid>
                        </>}
                    </Box>
                </Grid.Col>}
            </Grid>
        </Paper>

        {/* <Grid>
            {
                selectedKnowledge
                ? <Grid.Col span={{ base: 12, md: 12 }}>
                    <Group mb="md">
                        <ActionIcon onClick={() => setSelectedKnowledge(null)}>
                            <FaArrowLeft />
                        </ActionIcon>
                        <div style={{flex: 1}}></div>
                        <Button disabled={!selectedKnowledge.id} color="gray" variant="outline"
                            onClick={() => {
                                confirmDialog(
                                    { text: "Do you realy wants to delete this knowledge?" },
                                    ({ confirmed }) => {
                                        if(confirmed) DELETE_KNOWLEDGE(selectedKnowledge?.id)
                                        .then(() => {
                                            loadKnowledges();
                                            setSelectedKnowledge(null);
                                        })
                                        .catch(err => {
                                            notifications.show({ message: err.message })
                                        })
                                    }
                                )
                            }}
                        >Delete Item</Button>
                    </Group>

                    <Paper p="md" mb="md">
                        
                    </Paper>

                    <Group justify="flex-end" mt="md">
                        <Button size="md" onClick={handleSave} loading={loadingSave} color="green" className="draw-button">Save Item</Button>
                    </Group>
                </Grid.Col>
                : <Grid.Col span={{ base: 12, md: 12 }}>
                    <Group mb="md">
                        <InputField
                            name="pl"
                            style={{flex: 1}}
                            onChange={({pl}) => {
                                pl === "new"
                                ? setSelectedKnowledgeCategory({  })
                                : setSelectedKnowledgeCategory(knowledges.find(p => p.id === pl))
                            }}
                            value={selectedKnowledgeCategory ? selectedKnowledgeCategory?.id || "new" : null}
                            fieldType={InputFieldTypes.SELECT}
                            clearable={false}
                            options={[
                                ...knowledges.map(p => ({label: p.title, value: p.id}))
                                .sort((a,b) => a.label > b.label ? 1 : -1),
                                { value: "new", label: "Add new knowledge" }
                            ]}
                        />
                        {selectedKnowledgeCategory?.id && <Button color="gray" variant="outline"
                            onClick={() => {
                                confirmDialog(
                                    { text: "Do you realy wants to delete this category?" },
                                    ({ confirmed }) => {
                                        if(confirmed) DELETE_KNOWLEDGE_CATEGORY(selectedKnowledgeCategory?.id)
                                        .then(() => {
                                            loadKnowledges();
                                            setSelectedKnowledgeCategory(null);
                                        })
                                        .catch(err => {
                                            notifications.show({ message: err.message })
                                        })
                                    }
                                )
                            }}
                        >Delete Category</Button>}
                    </Group>

                </Grid.Col>
            }
        </Grid> */}

        <Modal
            opened={selectedKnowledgeCategory && !selectedKnowledgeCategory?.id}
            onClose={() => setSelectedKnowledgeCategory(null)}
        >
            {!userData?.user?.whitelabelAdmin && <Alert color="yellow" mb="md">
                <Text c="gray.0" size="md" ta="center" mb="md">{
                    str('KNOWLEDGE.PRICE_ALERT')
                        .replace(/\$/gi, userData?.plan?.currency ?? "USD")
                        .replace(/10/gi, userData?.plan?.knowledge_price ?? 10)
                }</Text>
            </Alert>}

            <InputField
                name="title"
                mb="md"
                onChange={({ title }) => setSelectedKnowledgeCategory(sp => ({ ...sp, title }))}
                value={selectedKnowledgeCategory?.title}
                title={str("TITLE")}
            />
            <Group justify="flex-end">
                <Button size="md" onClick={handleSaveCategory} loading={loadingSave} color="green">{
                    userData?.user?.whitelabelAdmin
                        ? str("CREATE")
                        : str("KNOWLEDGE.SUBSCRIBE")
                }</Button>
            </Group>
        </Modal>

        <Modal
            opened={!!selectedKnowledge}
            onClose={() => setSelectedKnowledge(null)}
        >
            <Stack>
                <InputField
                    name="type"
                    onChange={({ type }) => setSelectedKnowledge((sp: any) => ({ ...sp, type }))}
                    value={selectedKnowledge?.type ?? "simple"}
                    title={str("TYPE")}
                    options={[
                        { label: "Texts", value: 'simple' },
                        { label: "File", value: 'file' },
                        { label: "URLs", value: 'url' },
                    ]}
                    fieldType={InputFieldTypes.BOX}
                />
                {
                    selectedKnowledge?.type === "file"
                        ? <>
                            <InputField
                                name="title"
                                onChange={({ title }) => setSelectedKnowledge((sp: any) => ({ ...sp, title }))}
                                value={selectedKnowledge?.title}
                                title={str("TITLE")}
                            />
                            <InputField
                                name="url"
                                onChange={({ url }) => setSelectedKnowledge((sp: any) => ({ ...sp, url }))}
                                value={selectedKnowledge?.url}
                                title={str("FILE")}
                                accept={"*"}
                                fieldType={InputFieldTypes.FILE}
                            />
                        </>
                        : selectedKnowledge?.type === "url"
                            ? <Stack>
                                {(selectedKnowledge?.urls ?? []).map((it: string, i: number) => <Group>
                                    <InputField
                                        name="url"
                                        onChange={({ url }) => setSelectedKnowledge((sp: any) => ({ ...sp, urls: sp.urls.map((u: string, ui: number) => ui === i ? url : u) }))}
                                        value={it}
                                        style={{ flex: 1 }}
                                        placeholder="https://website.com"
                                    />
                                    <ActionIcon
                                        onClick={() => {
                                            setSelectedKnowledge((sp: any) => ({ ...sp, urls: sp.urls.filter((u: string, ui: number) => ui !== i) }))
                                        }}
                                    >
                                        <FaTrash />
                                    </ActionIcon>
                                </Group>)}
                                <Button
                                    onClick={() => {
                                        setSelectedKnowledge((sp: any) => ({ ...sp, urls: [...(sp.urls ?? []), ""] }))
                                    }}
                                    leftSection={<FaPlus />}
                                >{str("KNOWLEDGE.ADD_WEBSITE")}</Button>
                            </Stack>
                            : <>
                                <InputField
                                    name="title"
                                    onChange={({ title }) => setSelectedKnowledge((sp: any) => ({ ...sp, title }))}
                                    value={selectedKnowledge?.title}
                                    title={str("KNOWLEDGE.QUESTION")}
                                />
                                <InputField
                                    name="body"
                                    onChange={({ body }) => setSelectedKnowledge((sp: any) => ({ ...sp, body }))}
                                    value={selectedKnowledge?.body}
                                    title={str("KNOWLEDGE.ANSWER")}
                                    fieldType={InputFieldTypes.TEXTAREA}
                                />
                            </>
                }
                <Group justify="flex-end">
                    <Button size="md" onClick={() => handleDelete(selectedKnowledge?.id)} loading={loadingDelete} color="red">{str("DELETE")}</Button>
                    <Button size="md" onClick={handleSave} loading={loadingSave} color="green">{str("SAVE")}</Button>
                </Group>
            </Stack>
        </Modal>
    </div>
}
